import React from "react";
import TerminaleCucina from "./TerminaleCucina";

const TerminaleBar = () => <TerminaleCucina station="bar" />;
export default TerminaleBar;
